export default __webpack_public_path__ + "static/media/tex-mob.9fd18c0e.png";